import { render, staticRenderFns } from "./ClienteLayout.vue?vue&type=template&id=360ad5ae&scoped=true"
import script from "./ClienteLayout.vue?vue&type=script&lang=js"
export * from "./ClienteLayout.vue?vue&type=script&lang=js"
import style0 from "./ClienteLayout.vue?vue&type=style&index=0&id=360ad5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ad5ae",
  null
  
)

export default component.exports